export const SET_LOADING = "SET_LOADING";
export const STATUS_SUCCESS = "success";
// Constants for files types
export const CONTENT_TYPE_VIDEO = "CONTENT_TYPE_VIDEO"
export const CONTENT_TYPE_PDF = "CONTENT_TYPE_PDF"
export const CONTENT_TYPE_WORD = "CONTENT_TYPE_WORD"
export const CONTENT_TYPE_POWERPOINT = "CONTENT_TYPE_POWERPOINT"
export const TOGGLE_MODAL_PREVIEW_DOC = "TOGGLE_MODAL_PREVIEW_DOC"
export const SET_DATA_PREVIEW = "SET_DATA_PREVIEW"

// Questions
export const CHANGE_TXT_ANSWER = 'CHANGE_TXT_ANSWER';
export const CHANGE_TXT_QUESTION = 'CHANGE_TXT_QUESTION';
export const DRAW_SHAPE_QUESTION = 'DRAW_SHAPE_QUESTION';
export const DRAW_SHAPE_ANSWER = 'DRAW_SHAPE_ANSWER';
export const BLANK_FILL_TXT = '_________';
export const BLANK_FILL_SELECT = '___[.SELECT_FORM.]___';
export const BLANK_FILL_SELECT_SHORT = 'SELECT_FORM.]___';
export const BLANK_FILL_SELECT_SHORT_REPLACE = 'SELECT_FORM.]___';
export const TYPE_RADIO = 'radio';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_TRUE_FALSE_NO = 'answer_t_f_no';
export const TYPE_ESSAY = 'essay';
export const TYPE_MATH_COL = 'math_col';
export const TYPE_FILL_BLANK = 'fill_blank';
export const TYPE_FILL_SENTENCE = 'fill_sentence';
export const TYPE_SELECT = 'select';
export const TYPE_DOWN_ANSWER = 'down_answer';
export const TYPE_CIRCLE_ANSWER = 'circle_answer';
export const TYPE_X_MARK = 'x_mark_answer';
export const TYPE_GROUP = 'group';

export const TOGGLE_DRAW_SHAPE_TOOL = "TOGGLE_DRAW_SHAPE_TOOL";
export const DRAW_DATA = "DRAW_DATA";

// export const VALIDATE_QUESTION = 'VALIDATE_QUESTION';
// Comments
export const SET_COMMENT_DETAIL = 'SET_COMMENT_DETAIL';
export const SET_COMMENT_LIST = 'SET_COMMENT_LIST';
export const SET_PARAM_SEARCH_COMMENTS = 'SET_PARAM_SEARCH_COMMENTS';
export const SET_PARAM_SEARCH_COMMENT = 'SET_PARAM_SEARCH_COMMENT';
export const SET_PAGING_COMMENT = 'SET_PAGING_COMMENT';

export const ID_MODAL_REQUIRE_LOGIN = 'required_login';

export const ACTION_CHECK_CORRECT_QUESTION = 'ACTION_CHECK_CORRECT_QUESTION';
export const TOGGLE_GUIDE_ACTIVE_BOOK = 'TOGGLE_GUIDE_ACTIVE_BOOK';
export const SET_ID_ACTIVE_CODE_BOOK_HEADER = 'SET_ID_ACTIVE_CODE_BOOK_HEADER';
export const TOGGLE_MODAL_ACTIVE_PAGE = 'TOGGLE_MODAL_ACTIVE_PAGE';
export const SET_DOC_SLIDER_DATA = 'SET_DOC_SLIDER_DATA';
export const TOGGLE_MODAL_DOC_SLIDER = 'TOGGLE_MODAL_DOC_SLIDER';

export const TOGGLE_MODALACTIVE_BOOK = 'TOGGLE_MODALACTIVE_BOOK';
export const SET_BOOK_ACTIVE_WANT = 'SET_BOOK_ACTIVE_WANT';
export const SET_BOOK_ID_ACTIVE_SUCCESS = 'SET_BOOK_ID_ACTIVE_SUCCESS';
export const TOGGLE_MODAL_SHARE = 'TOGGLE_MODAL_SHARE';
export const SET_INFO_MEDIA_SHARE = 'SET_INFO_MEDIA_SHARE';
export const GET_COUNT_NOTIFI_NOT_RED = 'GET_COUNT_NOTIFI_NOT_RED';
export const MODAL_ID_REQ_INFO_DETAIL = "MODAL_ID_REQ_INFO_DETAIL";
export const SET_DATA_DETAIL_NOTIFI = "SET_DATA_DETAIL_NOTIFI";
export const SET_PARAM_DISPLAY = "SET_PARAM_DISPLAY";

export const ID_MODAL_SHOW_ERROR = "ID_MODAL_SHOW_ERROR"
export const ID_MODAL_SHOW_HELP = "ID_MODAL_SHOW_HELP"

export const TOGGLE_MODAL_SHOW_ERROR = "TOGGLE_MODAL_SHOW_ERROR"
export const TOGGLE_MODAL_SHOW_HELP = "TOGGLE_MODAL_SHOW_HELP"

export const SET_LIST_HELP = "SET_LIST_HELP"
export const SET_ID_DETAIL_HELP = "SET_ID_DETAIL_HELP"
export const GET_HELP_DETAIL = "GET_HELP_DETAIL"
export const GET_HELP_VIDEO = "GET_HELP_VIDEO"
export const SET_ROUTER_HELP = "SET_ROUTER_HELP"
export const GET_SHOW_VIDEO_HELP = "GET_SHOW_VIDEO_HELP"
export const SET_BOOKID_FOR_ERROR = "SET_BOOKID_FOR_ERROR"
export const SET_BOOK_INDEX_ID = "SET_BOOK_INDEX_ID"
export const SET_PAGE_NO_BOOK = "SET_PAGE_NO_BOOK"
export const SET_BOOK_PAGE_LINK_ID = "SET_BOOK_PAGE_LINK_ID"
export const ID_CLASS_1 = 1
export const ID_MATH_SUBJECT = 1
export const SET_QUESTION_ID = "SET_QUESTION_ID"
export const SET_INFO_LIBRARY = "SET_INFO_LIBRARY"
export const ACTION_SET_COUNT_VIEW = "ACTION_SET_COUNT_VIEW"
export const CHECK_PAGE_EXCERCISE = "CHECK_PAGE_EXCERCISE"
export const CHECK_SLIDE_ACTIVE_BOOK = "CHECK_SLIDE_ACTIVE_BOOK"
export const CHECK_ARRAY_SLIDE = "CHECK_ARRAY_SLIDE"
export const ID_MODAL_NOTIFY = "ID_MODAL_NOTIFY"
export const TOGGLE_MODAL_SHOW_NOTIFY = "TOGGLE_MODAL_SHOW_NOTIFY"
export const SET_DATA_MODAL_NOTI = "SET_DATA_MODAL_NOTI"
export const CHECK_INFO_EXCERCISE = "CHECK_INFO_EXCERCISE"
export const KEY_DEL_KEYBORAD = 46
export const FLE_DOWNLOAD_BEFORE = '[hanhtrangso.nxbgd.vn]'